import { FIELD_TYPES as FIELDS_TYPES } from "@hyro-components/fields/utils";

export const BRANCH_DEPLOYER_FIELDS = [
  { id: "releaseName", label: "Release Name" },
  { id: "dashboardClientTag", label: "Dashboard Client" },
  { id: "dashboardServerTag", label: "Dashboard Server" },
  { id: "deployDashboardInternal", label: "Deploy Dashboard Internal", type: "switch", defaultValue: false, tooltip: "Toggle to deploy the dashboard internal with the same commit of dashboard server" },
  { id: "configurationServiceTag", label: "Configuration Service" },
  { id: "dataServiceTag", label: "Data Service" },
  { id: "bot", label: "Agent Name" },
  { id: "nluRuntimeTag", label: "NLU Runtime" },
  { id: "widgetServerTag", label: "Widget Server" },
  { id: "useDraftConfiguration", label: "Use Draft", type: "switch", defaultValue: false, tooltip: "Use draft is relevant for the widget server, once you are toggling it to true, it will always take the connectors from the draft. Usable for testing voices, colors, and changes from settings" },
  { id: "widgetClientTag", label: "Widget Client" },
  { id: "nluRuntimeModes", label: "NLU Runtime Modes", options: ["dedicated", "api"] },
  { id: "ttlHours", label: "TTL (hours)" },
  { id: "memory", label: "Memory (Gi)" }
];

export const BRANCH_DEPLOYER_PRODUCTION_FIELDS = [
  { id: "releaseName", label: "Release Name" },
  { id: "bot", label: "Agent Name" },
  { id: "useDraftConfiguration", label: "Use Draft", type: "switch", defaultValue: false, tooltip: "Use draft is relevant for the widget server, once you are toggling it to true, it will always take the connectors from the draft. Usable for testing voices, colors, and changes from settings" },
  { id: "assistantId", label: "Agent ID" },
  { id: "configId", label: "Config ID" },
  { id: "ttlHours", label: "TTL (hours)" },
  { id: "memory", label: "Memory (Gi)" }
];

export const BRANCH_DEPLOYER_WITH_CONFIG_ID_FIELDS = [
  { id: "releaseName", label: "Release Name" },
  { id: "dashboardClientTag", label: "Dashboard Client" },
  { id: "dashboardServerTag", label: "Dashboard Server" },
  { id: "deployDashboardInternal", label: "Deploy Dashboard Internal", type: "switch", defaultValue: false, tooltip: "Toggle to deploy the dashboard internal with the same commit of dashboard server" },
  { id: "configurationServiceTag", label: "Configuration Service" },
  { id: "dataServiceTag", label: "Data Service" },
  { id: "configId", label: "Config ID" },
  { id: "assistantId", label: "Agent ID" },
  { id: "nluRuntimeTag", label: "NLU Runtime" },
  { id: "widgetServerTag", label: "Widget Server" },
  { id: "useDraftConfiguration", label: "Use Draft", type: "switch", defaultValue: false, tooltip: "Use draft is relevant for the widget server, once you are toggling it to true, it will always take the connectors from the draft. Usable for testing voices, colors, and changes from settings" },
  { id: "widgetClientTag", label: "Widget Client" },
  { id: "nluRuntimeModes", label: "NLU Runtime Modes", options: ["dedicated", "api"] },
  { id: "ttlHours", label: "TTL (hours)" },
  { id: "memory", label: "Memory (Gi)" }
];

export const NUMERIC_FIELD_CONSTRAINTS = {
  MEMORY: { min: 1, max: 10, default: 4 }
};

export const VIEW_DETAILS_FIELDS = [
  { id: "dashboardServerUrl", label: "Dashboard Server url" },
  { id: "dashboardClientUrl", label: "Dashboard Client url" },
  { id: "assistantsApiUrl", label: "Assistants API url" },
  { id: "assistantsPreviewUrl", label: "Assistants preview url" },
  { id: "assistantsUrl", label: "Assistants url" },
  { id: "widgetServerUrl", label: "Widget Server url" },
  { id: "widgetClientUrl", label: "Widget Client url" },
  { id: "dashboardInternalUrl", label: "Dashboard Internal url" },
  { id: "dataServiceUrl", label: "Data Service url" }
];

export const BRANCH_DEPLOYER_STORAGE_KEY = "branchDeployerValues";

export const BRANCH_DEPLOYER_INITIAL_DATA = {
  releaseName: "",
  dashboardClientTag: "",
  dashboardServerTag: "",
  configurationServiceTag: "",
  dataServiceTag: "",
  bot: "",
  nluRuntimeTag: "",
  widgetServerTag: "",
  useDraftConfiguration: false,
  deployDashboardInternal: false,
  widgetClientTag: "",
  nluRuntimeModes: [],
  ttlHours: "24",
  configId: "",
  assistantId: "",
  memory: String(NUMERIC_FIELD_CONSTRAINTS.MEMORY.default)
};

export const BRANCH_DEPLOYER_WITH_CONFIG_ID_INITIAL_DATA = {
  releaseName: "",
  dashboardClientTag: "",
  dashboardServerTag: "",
  configurationServiceTag: "",
  dataServiceTag: "",
  configId: "",
  assistantId: "",
  nluRuntimeTag: "",
  widgetServerTag: "",
  useDraftConfiguration: false,
  deployDashboardInternal: false,
  widgetClientTag: "",
  nluRuntimeModes: [],
  ttlHours: "24",
  memory: String(NUMERIC_FIELD_CONSTRAINTS.MEMORY.default)
};

export const FIELD_TYPES = {
  RELEASE_NAME: "releaseName",
  DASHBOARD_CLIENT: "dashboardClientTag",
  DASHBOARD_SERVER: "dashboardServerTag",
  CONFIGURATION_SERVICE: "configurationServiceTag",
  DATA_SERVICE: "dataServiceTag",
  BOT: "bot",
  ASSISTANT_ID: "assistantId",
  CONFIG_ID: "configId",
  NLU_RUNTIME: "nluRuntimeTag",
  WIDGET_SERVER: "widgetServerTag",
  WIDGET_CLIENT: "widgetClientTag",
  NLU_RUNTIME_MODES: "nluRuntimeModes",
  TTL: "ttlHours",
  MEMORY: "memory"
};

export const COLUMNS = {
  releaseName: { id: "releaseName", label: "Release Name", enableFilter: true },
  link: { id: "dashboardClientUrl", label: "Dashboard", enableFilter: false },
  previewLink: { id: "sharePerviewUrl", label: "Preview", enableFilter: false },
  chat: { id: "snippet", label: "Snippet", enableFilter: false },
  voice: { id: "snippet", label: "Voice", enableFilter: false },
  expired: { id: "expired", label: "Expires in", enableFilter: false },
  services: { id: "services", label: "Services", enableFilter: true },
  userEmail: { id: "createdBy", label: "Creator", enableFilter: true },
  editorEmail: { id: "lastUpdatedBy", label: "Last Editor", enableFilter: true },
  status: { id: "status", label: "Status", enableFilter: true, filterType: FIELDS_TYPES.CHOOSE_AT_LEAST_ONE, options: Object.values(["Live", "Pending", "Expired", "Terminated", "KG Update", "Failed"]).map((status) => ({ key: status, display_key: status })) }
};

export const KEYS_TO_FILTER = Object.keys(BRANCH_DEPLOYER_INITIAL_DATA);
export const KEYS_TO_FILTER_WITH_CONFIG_ID = Object.keys(BRANCH_DEPLOYER_WITH_CONFIG_ID_INITIAL_DATA);
export const DIALOG_TYPES = {
  create: { id: "create", display: "Create" },
  edit: { id: "edit", display: "Edit" },
  reactivate: { id: "reactivate", display: "Reactivate" },
  viewDetails: { id: "viewDetails", display: "View Details" },
  deactivate: { id: "deactivate", display: "Deactivate" },
  refresh: { id: "refresh", display: "Refresh Status" }
};

export const CREATE_DIALOG = {
  title: "Create new branch deployer",
  subtitle: "Please enter the following details to create a new branch deployer.\nUse 'latest' to create a branch deployer with the latest version.",
  buttonText: "Create"
};

export const EDIT_DIALOG = {
  title: "Update selected branch deployer",
  subtitle: "You are about to make some changes to a branch deployer",
  buttonText: "Save"
};

export const REACTIVATE_DIALOG = {
  title: "Reactivate selected branch deployer",
  subtitle: "You are about to reactivate the branch deployer $branchDeployerName.",
  buttonText: "Reactivate"
};

export const DEACTIVATE_DIALOG = {
  title: "Deactivate selected branch deployer",
  subtitle: "Are you sure you want to deactivate the branch deployer $branchDeployerName?",
  buttonText: "Deactivate"
};

export const VIEW_DETAILS_DIALOG = {
  title: "Branch Deployer Details",
  subtitle: "Here are the details of the branch deployer $branchDeployerName."
};

export const COPY_SNIPPET_SUCCESS_MESSAGE = "Successfully copied snippet";
export const EDIT_LINK_NOT_FOUND_MESSAGE = "Branch deployer \"$releaseName\" was not found.";
export const EDIT_LINK_NOT_EDITABLE_MESSAGE = "Branch deployer \"$releaseName\" can't be edited.";

export const STATUS_TYPES = {
  LIVE: "Live",
  PENDING: "Pending",
  EXPIRED: "Expired",
  TERMINATED: "Terminated",
  KG_UPDATE: "KG Update",
  FAILED: "Failed"
};
export const BD_STATUS_TO_CHIP = {
  [STATUS_TYPES.LIVE]: {
    backgroundColorPath: ["success", "200"],
    textColorPath: ["success", "700"]
  },
  [STATUS_TYPES.PENDING]: {
    backgroundColorPath: ["warning", "300"],
    textColorPath: ["warning", "600"]
  },
  [STATUS_TYPES.EXPIRED]: {
    backgroundColorPath: ["grey", "200"],
    textColorPath: ["text", "600"]
  },
  [STATUS_TYPES.TERMINATED]: {
    backgroundColorPath: ["error", "300"],
    textColorPath: ["error", "600"]
  },
  [STATUS_TYPES.KG_UPDATE]: {
    backgroundColorPath: ["warning", "300"],
    textColorPath: ["warning", "600"]
  },
  [STATUS_TYPES.FAILED]: {
    backgroundColorPath: ["error", "300"],
    textColorPath: ["error", "600"]
  }
};

export const FILTERS = Object.values(COLUMNS)
  .filter((column) => column.enableFilter)
  .map((column) => ({
    key: column.id,
    label: column.label,
    type: column.filterType || FIELDS_TYPES.TEXT,
    options: column.options || []
  }));
